module.exports = __webpack_public_path__ + "img/may-britt-3.jpg";